package api


import dev.gitlive.firebase.*
import dev.gitlive.firebase.externals.FirebaseOptions
import dev.gitlive.firebase.initialize

object FirebaseConfig {
    private val firebaseOptions = FirebaseOptions(
        applicationId = "1:764123589236:web:fdb07ce00ba4c77406ff21",
        apiKey = "AIzaSyApgTR6VO2cedHjpnkBcG9jAXMV2-MpmqI",
        databaseUrl = "https://boonco-426899.firebaseio.com",
        storageBucket = "boonco-426899.firebasestorage.app",
        projectId = "boonco-426899",
        authDomain = "boonco-426899.firebaseapp.com"
    )
    fun init() = Firebase.initialize(options = firebaseOptions)
}